{
  "es": {
    "todo_group": {
      "actions": {
        "create": "Tarea",
        "update": "Editar tarea"
      },
      "attributes": {
        "category": "Categoría",
        "created_at": "Creado",
        "description": "Descripción",
        "title": "Título",
        "todos_count": "Tareas",
        "units": "Unidades"
      },
      "categories": {
        "confirmation": "Confirmación",
        "upload": "Subida"
      },
      "labels": {
        "no_groups": "Todavía no hay tareas para este proyecto.",
        "required": "Este campo es obligatorio"
      },
      "toasts": {
        "create": "Tarea creada",
        "delete": "Tarea eliminada",
        "update": "Tarea actualizada"
      }
    }
  }
}
